function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2759 0.299916C13.369 0.204959 13.4801 0.129523 13.6027 0.0780243C13.7252 0.0265258 13.8569 0 13.9898 0C14.1228 0 14.2544 0.0265258 14.377 0.0780243C14.4996 0.129523 14.6106 0.204959 14.7037 0.299916C15.0937 0.694015 15.0992 1.33085 14.7173 1.73176L6.65399 11.2638C6.56244 11.3643 6.45135 11.4451 6.3275 11.5012C6.20365 11.5573 6.06966 11.5876 5.93371 11.5902C5.79777 11.5927 5.66273 11.5675 5.53686 11.5161C5.411 11.4646 5.29695 11.3881 5.20169 11.2911L0.295222 6.31913C0.105996 6.12615 0 5.86666 0 5.59639C0 5.32612 0.105996 5.06662 0.295222 4.87365C0.388287 4.77869 0.499361 4.70325 0.621941 4.65175C0.74452 4.60026 0.876142 4.57373 1.0091 4.57373C1.14206 4.57373 1.27368 4.60026 1.39626 4.65175C1.51884 4.70325 1.62991 4.77869 1.72298 4.87365L5.88488 9.09146L13.2487 0.329917C13.2571 0.319378 13.2663 0.30936 13.2759 0.299916Z",
  fill: "white"
});

function SvgV(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgV);
export default __webpack_public_path__ + "static/media/v.8a2315fc.svg";
export { ForwardRef as ReactComponent };